Array.prototype.removeDuplicates = function () {
    var target = this;
    return target.filter((filterItem, index, self) => self.indexOf(filterItem) === index);
};
